import { CookieConsent } from '@web_opxp/features';
import React, { useEffect, useMemo, useState } from 'react';
import { getPrivacyPolicyUrl } from '../base/historyService';

interface ICookieBannerWrapperProps {
  language?: string;
}

export const CookieBannerWrapper: React.FC<ICookieBannerWrapperProps> = ({ language }: ICookieBannerWrapperProps) => {
  const [privacyUrl, setPrivacyUrl] = useState('');
  const policyUrl = useMemo(() => {
    if (!language) {
      return '';
    }
    return !language ? '' : getPrivacyPolicyUrl(language);
  }, [language]);
  useEffect(() => {
    setPrivacyUrl(policyUrl);
  }, [policyUrl]);
  return <CookieConsent privacyUrl={privacyUrl} />;
};

export default CookieBannerWrapper;
